import React, { memo, useState, MouseEvent } from "react";
import { Grid, Typography, CardActions, Button, makeStyles } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import useUserProfile from "../../../Hook/useUserProfile";
import UserAvatar from "jb_component_library/components/UserAvatar";
import { LocationSelection } from "../LocationSelection/LocationSelection";
import useInitialAppData from "../../../Hook/UseInitialAppData";
import { useTenant } from "../../Context/TenantProvider";
import AustraliaFilled from "../../IconComponents/AustraliaFilled";
import NewZealandFilled from "../../IconComponents/NewZealandFilled";

const useStyles = makeStyles((theme) => ({
	card: {
		maxWidth: '250px'
	},
	actions: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	container: {
		justifyContent: 'flex-start', 
		alignItems: 'center',
		marginBottom: 8
	}
}))

const UserDetail: React.MemoExoticComponent<React.FC<{ logout: () => Promise<void> }>> = memo(
	(props: { logout: () => Promise<void> }) => {
		const [anchorEl, setAnchorEl] = useState<Element | null>(null);
		const handleClose = () => {
			setAnchorEl(null);
		};
		const handleMenu = (event: MouseEvent) => {
			setAnchorEl(event.currentTarget);
		};
		const userProfile = useUserProfile();
		const initialAppData = useInitialAppData();
		const roles = 
			initialAppData.userInformation.roles.length > 0 ? initialAppData.userInformation.roles.join(", ") : "Default Access";

		const { currentCountry } = useTenant();
		const countryImage = currentCountry.toUpperCase() === "AU" ? <AustraliaFilled size={"s"}/> : <NewZealandFilled size={"s"}/>;

		const classes = useStyles();

		if (userProfile) {
			return (
				<React.Fragment>
					<Button onClick={handleMenu}>
						<UserAvatar
							name={userProfile.displayName}
							size={44}
							fontSize={30}
							fontSizeUnit="px"
							userPhoto={`data:image/png;base64,${userProfile.photo}`}
						></UserAvatar>
					</Button>
					<Popover
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={handleClose}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "right",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "right",
						}}
					>
						<Card className={classes.card}>
							<CardContent>
								<Grid container spacing={1} className={classes.container}>
									<Grid item>
										<UserAvatar
											name={userProfile.displayName}
											size={60}
											fontSize={40}
											fontSizeUnit="px"
											userPhoto={`data:image/png;base64,${userProfile.photo}`}
										></UserAvatar>
									</Grid>
									<Grid item>
										<Typography variant="h6" component="div">
											{userProfile.displayName}
										</Typography>
										<Typography variant="subtitle1" component="div">
											{userProfile.staffId}
										</Typography>
									</Grid>
								</Grid>
								<Grid container className={classes.container}>
									<LocationSelection/>
								</Grid>
								<Grid container className={classes.container}>
									<Grid item xs={12}>
										<Typography variant="h6">
											Country
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="subtitle1">
											{countryImage} {currentCountry}
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="h6">
											Device IP
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="subtitle1">
											{initialAppData.userInformation.ipAddress}
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="h6">
											Roles
										</Typography>
									</Grid>
									<Grid item xs={12}>
										<Typography variant="subtitle1" component="div">
											{roles}
										</Typography>
									</Grid>
								</Grid>
							</CardContent>
							<CardActions className={classes.actions}>
								<Button variant="contained" color="primary" onClick={props.logout}>
									Sign out
								</Button>
							</CardActions>
						</Card>
					</Popover>
				</React.Fragment>
			);
		}
		return <div></div>;
	}
);

export default UserDetail;
